import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function PastaPage() {

    const heroData = [
        {
          title: "Pasta",
          content: "Discover the soul of Italian cuisine with our pasta dishes, made with freshly prepared sauces and high-quality ingredients. From creamy Alfredo to zesty Arrabbiata, every plate is a celebration of flavor.",
          image: images.PastaHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Arabiata",
        content: "Spicy tomato sauce with garlic, chili, and olive oil over al dente pasta",
        price: 0,
        image: [
          images.Pasta1,
        ]
      },
      {
        name: "Chicken Alfredo",
        content: "Creamy Alfredo sauce with tender chicken over perfectly cooked pasta",
        price: 0,
        image: [
          images.Pasta2,
        ]
      },
      {
        name: "Shrimp Aglio e Olio",
        content: "Shrimp sautéed in garlic, olive oil, and chili, tossed with al dente pasta",
        price: 0,
        image: [
          images.Pasta3,
        ]
      },
      {
        name: "Pesto Primavera",
        content: "Fresh seasonal vegetables and al dente pasta tossed in a vibrant pesto sauce",
        price: 0,
        image: [
          images.Pasta3,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Chicken Alfredo",
        image1: [
          images.Pasta2,
        ],
        content1: "Creamy Alfredo sauce with tender chicken over perfectly cooked pasta",
        name2: "Shrimp Aglio e Olio",
        image2: [
          images.Pasta3,
        ],
        content2: "Shrimp sautéed in garlic, olive oil, and chili, tossed with al dente pasta"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
